import React from 'react';
import styled from 'styled-components';

const ServerInfoStyled = styled.section`
  margin: 14px 0;
  
  .label {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.45);
    font-weight: 500;
    margin-bottom: 3px;
    display: block;
  }
  
  div {
    margin-top: 3px;
    background-color: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.05);
    padding: 6px 10px;
    border-radius: 6px;
    font-family: Consolas, monospace;
    font-size: 13px;
    color: rgba(255, 255, 255, 0.9);
    transition: all 0.2s ease;
    word-break: break-all;
    
    &:hover {
      background-color: rgba(255, 255, 255, 0.05);
      border-color: rgba(255, 255, 255, 0.08);
    }
  }
`;

const ServerComInfo = ({ name, data, onClick, title, style }) => {
    return (
        <ServerInfoStyled>
            <span className='label'>
                { name }:
            </span>
            <div 
                onClick={ onClick } 
                title={ title } 
                style={{ ...style, ...(onClick ? { cursor: 'pointer' } : {}) }}
            >
                { data }
            </div>
        </ServerInfoStyled>
    );
};

export default ServerComInfo;